const commonStyles = {
  bottom: 'auto',
  top: 'auto',
  left: 'auto',
  right: 'auto',
  position: 'relative',
  background: 'white',
  border: '1px solid #ccc',
};
export const customStylesMobile = {
  content: {
    ...commonStyles,
    top: '0%',
    left: '50%',
    transform: 'translate(-50%,0%)',
  },
};
export const customStylesDesktop = {
  content: {
    ...commonStyles,
    width: '798px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
};
